export default __webpack_public_path__ + "assets/images/rupay-white.769cc8cda4ded2c265c708b8c4a3dfa4.svg";